import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import {fromEvent, Observable, of, Subject} from 'rxjs';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  switchMap, take,
  takeUntil,
  tap
} from 'rxjs/operators';
import {StudentsService, UserSearchResult} from '../../../../../services/students/students.service';
import {AuthService} from '../../../auth/services/auth.service';
import {DirectorySearchResult} from "../../../../../services/directory/directory.model";


@Component({
  selector: 'app-directory-search',
  templateUrl: './directory-search.component.html',
  styleUrls: ['./directory-search.component.scss']
})
export class DirectorySearchComponent implements OnInit, OnDestroy {

  @Input() clearOnSelect: boolean;
  @Input() showRequired: boolean;
  @Input() userEmail: string | void;
  @Input() clear: Observable<any>;
  @Output() userSelected: EventEmitter<UserSearchResult> = new EventEmitter();
  @ViewChild('ngSelectElement') ngSelectElement: NgSelectComponent;
  students$: Observable<DirectorySearchResult[]>;
  studentsSearchTerm$ = new Subject<string>();
  selectedStudent: DirectorySearchResult;
  searching = false;
  onDestroy$ = new Subject<void>();
  constructor(
    private auth: AuthService,
    private studentService: StudentsService
  ) {}

  ngOnInit(): void {
    this.auth.appUser$.pipe(
      filter((user) => !!user.customer),
      takeUntil(this.onDestroy$)
    ).subscribe((user) => {
      this.studentService.setCustomerId(user.customer.customerId);
    });
    this.loadUsers();
    if (this.userEmail) {
      this.searching = true;
      this.students$.pipe(take(1)).subscribe((students) => {
        this.searching = false;
        if (students.length === 1) {
          this.selectedStudent = students[0];
        } else {
          console.error('Failed to find correct prefill student', this.userEmail);
        }
      });
      this.studentsSearchTerm$.next(this.userEmail);
    }

    if (this.clear) {
      this.clear.subscribe((value) => {
        // console.log('clear', value);
        this.studentsSearchTerm$.next(null);
        this.selectedStudent = null;
      });
    }
    fromEvent(window, 'resize').pipe(
      takeUntil(this.onDestroy$),
      debounceTime(50))
      .subscribe(this.onWindowResize_);
  }

  onChange(user: UserSearchResult): void {
    if (user) {
      setTimeout(() => {
        if (this.clearOnSelect) {
          this.selectedStudent = null;
          this.ngSelectElement.clearModel();
        }
        this.userSelected.emit(user);
      });
    }
  }

  clearValue(): void {
    this.selectedStudent = null;
    setTimeout(() => {
      if (this.clearOnSelect) {
        this.selectedStudent = null;
        this.ngSelectElement.clearModel();
      }
      this.userSelected.emit(null);
    });
  }

  getDefaultPhotoUrl(): string {
    return StudentsService.defaultPhotoUrl;
  }

  ngOnDestroy(): void {
    this.onDestroy$.next(null);
  }

  getSchoolList(schools: any[]): string {
    return schools.map((school) => (`${school.name} (${school.shortCode})`)).join(', ');
  }

  private onWindowResize_(): void {
    const selContainer = document.getElementsByClassName('select-container')[0];
    const panel = document.getElementsByClassName('ng-dropdown-panel')[0] as HTMLElement;
    if (panel) {
      const {x ,y ,width, height, bottom} = selContainer.getBoundingClientRect();
      panel.style.left = `${x}px`;
      panel.style.top = `${bottom}px`;
      panel.style['max-width'] = `${width}px`;
    }
  }

  private loadUsers(): void {
    this.students$ = this.studentsSearchTerm$.pipe(
      debounceTime(750),
      distinctUntilChanged(),
      switchMap(term => {
        if (term) {
          this.searching = true;
          return this.studentService.searchForStudents(term).pipe(
            map(response => response.data));
        } else {
          return of([]);
        }
      }),
      tap(() => this.searching = false),
      catchError(() => of([])), // empty list on error
    );
  }
}
